<template>
  <div>
    <el-table :data="tableData" border>
      <el-table-column prop="ids" label="序号" align="center" width="60"></el-table-column>
      <el-table-column prop="agreementAccount" label="用户账户" align="center"></el-table-column>
      <el-table-column prop="phone" label="支付手机号" align="center"></el-table-column>
      <el-table-column prop="productName" label="套餐名" align="center"></el-table-column>
      <el-table-column prop="createTime" label="扣款时间" align="center" sortable></el-table-column>
      <el-table-column prop="price" label="扣款金额" align="center"></el-table-column>
      <el-table-column prop="status" label="状态" align="center"></el-table-column>
      <el-table-column prop="remark" label="备注" align="center"></el-table-column>
    </el-table> 
  </div>
</template>
<script>
import { agreementAgreementModifyList } from "@/api/api.js"; //变更列表
export default {
  data() {
    return{
      tableData:[]
    }
  },
  methods: {
    // 获取列表的数据
    initData(){
      let params ={
        id:this.$route.query.id
      }
      agreementAgreementModifyList(params).then(res=>{
        if(res.data.code == 200 ){
          this.tableData = res.data.data;
          this.tableData.map((item,index)=>{
            item.ids = index + 1;
            item.productName = JSON.parse(item.productInfo).productName
            item.status = item.status == "1" ? "成功" : "失败"
          })
        }
      })
    },

  },

  mounted() {

  },
  created() {
    
  }
};
</script>

<style scoped lang="less">

</style>


